import React from 'react'
import Link from 'gatsby-link'

import Layout from '../components/layout'

const VolunteerPage = () => (
  <Layout>
    <article className="cf ph3 ph5-ns pt5">
      <div className="fn fl-ns w-40-ns pr4-ns">
        <h1 className="f2 lh-title fw9 mb3 mt0 pt3 bt bw2">
          Volunteer
        </h1>
        <h2 className="f4 mid-gray lh-title">
        <Link className="fw7 link dim turquoise" to="/volunteer-application" title="Volunteer Application">Apply online</Link> 
        <br/>or your application to <a href="mailto:info@rivertonarts.org.nz" target="_blank" rel="noopener noreferrer">info@rivertonarts.org.nz</a>
        </h2>
      </div>
      <div className="fn fl-ns w-60-ns">
        <h3 className="turquoise mt0">Volunteer Job Description</h3>
        <p className="measure">
        The gallery assistant greets visitors arriving at the Arts Centre and processes art sales and assist visitors with purchases or information.
        </p>
        <h3 className="turquoise">Location</h3>
        <p className="measure">   
        Riverton Community Arts Centre<br/>
        149 Palmerston Street<br/>
        Riverton Aparima<br/>
        Southland
        </p>
        <h3 className="turquoise">Regular Duties</h3>
        <p className="measure">
            <ul>
                <li>Opening and Closing gallery</li>
                <li>Greeting and attending to visitors</li>
                <li>Process sales, receipting, Eftpos</li>
                <li>Provide visitors with information about our town and the other arts resources that are available locally. (Studio 120, The Good Studio, The Vault, Te Hikoi)</li>
                <li>Receiving donations and sales of retail items such as cards and magazines</li>
                <li>Encouraging membership and volunteering where appropriate</li>
                <li>Checking gallery is clean and tidy for next open day</li>
                <li>Answering the phone and passing on any message to the Administrator or Wayne Hill.</li>
                <li>Recording visitor numbers</li>
                <li>Encouraging guests to sign visitors’ book</li>
                <li>Packaging Art</li>
                <li>Tidying and organising gallery</li>
                <li>Other duties as requested by Art Centre staff and trustees</li>
          </ul>
        </p>
        <p className="measure">
        Art Centre volunteers are managed by the Centre Administrator and Chairperson.  Volunteers may also have contact with other trustees and committee members.  Volunteers will be invited to attend exhibition openings and other events.  The Arts Centre is a charitable organisation and is funded by grants, donations and events put on by the Centre.  The support of professional, reliable volunteers enables us to carry out our mission of providing arts experiences, exhibitions, education and events to Riverton and the surrounding district.  
        </p>
        <h3 className="turquoise">Commitment Expected</h3>
        <p className="measure">
        We need reliable, capable people to manage the gallery.  If you can do shifts on a regular day and time, that is very helpful to us when planning exhibitions. Each shift is two and a half hours long, and a whole day shift is five hours.  Reliability and arriving on time are important.  Rosters are sent by email and a prompt reply with dates and times helps us to plan.  The gallery is open Wednesday till Sunday from 11am till 4pm during exhibitions.  First shift is 11am till 130pm and second shift 1.30pm till 4pm.
        </p>
        <p className="measure">
        We would appreciate a commitment of at least one rostered shift for short exhibitions and two for longer exhibitions.
        </p>
        <p className="measure">
        <h3 className="turquoise">Qualifications and Attitude</h3>
        <ul>
            <li>Customer service</li>
            <li>Arts knowledge/experience</li>
            <li>Positive and enthusiastic</li>
            <li>Reliable</li>
            <li>Local knowledge</li>
            <li>Retail</li>
        </ul>
        <h3 className="turquoise">Training</h3>
        <ul>
            <li>Orientation will be provided</li>
            <li>One on one support from Administrator and Wayne Hill</li>
            <li>Attend openings and meet artists and others in the arts community</li>
            <li>Eftpos</li>
        </ul>
        <h3 className="turquoise">Dress Code</h3>
        <ul>
            <li>Business casual</li>
        </ul>
        </p>
        <p className="measure">For more information or to apply to volunteer at the Riverton Community Arts Centre please email <a className="b" href="mailto:info@rivertonarts.org.nz">info@rivertonarts.org.nz</a></p>
      </div>
    </article>
  </Layout>
)

export default VolunteerPage
